import APP from '../../../main.js'
import AppRecord from './AppRecord.js'

class MailGroup extends AppRecord {
  get mail_group_users(){
    return this.constructor.employeeStore.mail_group_users.filter(rec => rec.mail_group_id === this.id)
  }
}
export default MailGroup
